module.exports = __webpack_public_path__ + "static/media/icon-arrow.2f14c732.svg";